import { useEffect, useState } from "react";

/**
 * Cookie Banner — DSGVO/TTDSG Stufe 1
 *
 * Stufe 1 = nur technisch notwendige Cookies (Session, Locale).
 * Kein Tracking, kein Google Analytics, kein Facebook Pixel — daher kein
 * Opt-In/Opt-Out-Mechanismus nötig. Nutzer wird transparent informiert.
 *
 * Wird einmal bestätigt → localStorage merkt sich das.
 */
const STORAGE_KEY = "patrice_cookie_ack_v1";

export const CookieBanner = () => {
  const [open, setOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    } catch {
      // ignore — privacy mode etc.
    }
    setMounted(true);
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch {}
    setOpen(false);
  };

  if (!mounted || !open) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="region"
      aria-label="Cookie-Hinweis"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-50"
      style={{
        animation: "cookieFadeIn 600ms cubic-bezier(.2,.7,.2,1) both",
      }}
    >
      <div
        className="backdrop-blur-xl border p-6 md:p-7 shadow-xl"
        style={{
          background: "rgba(40, 0, 27, 0.94)",
          color: "#FAF7F2",
          borderColor: "rgba(203, 183, 176, 0.35)",
        }}
      >
        <p className="font-mono text-[0.6rem] tracking-[0.32em] uppercase" style={{ color: "#FF7100" }}>
          — Cookies & Datenschutz
        </p>
        <h2 className="font-display text-xl md:text-2xl mt-3 leading-snug">
          <em className="italic-serif">Nur das Nötigste.</em>
        </h2>
        <p className="mt-3 text-sm font-light leading-relaxed text-warmth/95">
          Diese Website setzt ausschließlich technisch notwendige Cookies, damit Sprache
          und Sitzung funktionieren. Kein Tracking, kein Werbe-Pixel, keine Drittanbieter-Analyse.
        </p>
        <p className="mt-2 text-sm font-light leading-relaxed text-warmth/80">
          Mehr Details in der{" "}
          <a
            href="/sgb/datenschutz"
            className="underline underline-offset-2 hover:text-canvas"
            data-testid="cookie-link-privacy"
          >
            Datenschutzerklärung
          </a>
          .
        </p>
        <div className="mt-6 flex items-center gap-5">
          <button
            type="button"
            onClick={accept}
            data-testid="cookie-accept"
            className="px-6 py-3 font-mono text-[0.62rem] tracking-[0.32em] uppercase border border-canvas/40 hover:bg-canvas hover:text-depth transition-colors"
          >
            Verstanden
          </button>
        </div>
      </div>
      <style>{`
        @keyframes cookieFadeIn {
          from { opacity: 0; transform: translateY(16px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
